import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageCircle } from "lucide-react";

// Item 19: every WhatsApp button opens the linked customer GROUP (1:1 only when preferred / linked chat is the 1:1).
export function useWaBlock(recordId) {
  const [wa, setWa] = useState(null);
  const reload = () => api.get(`/cases/${recordId}/whatsapp`).then((r) => setWa(r.data)).catch(() => setWa(null));
  useEffect(() => { reload(); }, [recordId]); // eslint-disable-line
  return [wa, reload];
}

export function WaButton({ wa, onGoWhatsApp, testid = "whatsapp-link", small }) {
  const cls = `flex items-center gap-1.5 ${small ? "text-xs" : "text-sm"} rounded-lg px-3 py-1.5 transition-colors`;
  if (!wa) return <span className={`${cls} border border-[#E2E2E2] text-[#C5C4C4]`} data-testid={testid}>WhatsApp</span>;
  if (wa.customer_open_link) {
    return <a href={wa.customer_open_link} target="_blank" rel="noreferrer" data-testid={testid}
      title={wa.has_customer_group && !wa.prefers_1to1 ? "Opens the customer group" : "Opens the 1:1 chat"}
      className={`${cls} text-[#159A50] border border-[#159A50]/30 hover:bg-[#159A50]/5`}><MessageCircle className="w-4 h-4" /> WhatsApp</a>;
  }
  return (
    <div className="flex items-center gap-1.5" data-testid={`${testid}-nogroup`}>
      <button onClick={onGoWhatsApp} data-testid={testid} className={`${cls} border border-[#F5B71D]/60 text-[#92600a] bg-[#F5B71D]/10 hover:bg-[#F5B71D]/20`}>
        <MessageCircle className="w-4 h-4" /> Link the customer group first
      </button>
      {wa.customer_dm_link && <a href={wa.customer_dm_link} target="_blank" rel="noreferrer" data-testid={`${testid}-dm`} className="text-[11px] text-[#6B7280] hover:underline whitespace-nowrap">Message directly instead</a>}
    </div>
  );
}
